import { errorThatWillCauseAlert } from 'owa-trace';
import { getStaticBehavior } from './getStaticBehavior';
import { getStaticData } from './getStaticData';
import { AppBarControlDocument } from './graphql/queries/__generated__/AppBarBootstrapData.interface';
import { ControlModelDocument } from './graphql/queries/__generated__/ControlModel.interface';

import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';

export async function bootstrapAppBarCache(client: ApolloClient<NormalizedCacheObject>) {
    try {
        client.writeQuery({ query: ControlModelDocument, data: getStaticBehavior() });
        client.writeQuery({ query: AppBarControlDocument, data: await getStaticData() });
    } catch (e) {
        errorThatWillCauseAlert('AppBar_CachePriming_Error', e);
    }
}
